<template>
  <div>
    <breadcrumbs home="Customers"/>

    <import-csv v-model="doImport" type="customers"
                :fields="[{name:'Name',mapTo:'',mandatory:true},
                          {name:'Address 1',mapTo:'',mandatory:false},
                          {name:'Address 2',mapTo:'',mandatory:false},
                          {name:'City',mapTo:'',mandatory:false},
                          {name:'Province',mapTo:'',mandatory:false},
                          {name:'Postal code',mapTo:'',mandatory:false},
                          {name:'Email',mapTo:'',mandatory:false},
                          {name:'Phone',mapTo:'',mandatory:false},
                          {name:'Type',mapTo:'',mandatory:false},
                          {name:'License',mapTo:'',mandatory:false},
                          {name:'Currency',mapTo:'',mandatory:false},
                          {name:'Contact name',mapTo:'',mandatory:false},
                          {name:'Contact title',mapTo:'',mandatory:false},
                          {name:'Contact email',mapTo:'',mandatory:false},
                          {name:'Contact phone',mapTo:'',mandatory:false},
                          {name:'Category',mapTo:'',mandatory:false},
                          {name:'Shipment zone',mapTo:'',mandatory:false}
                          ]"
              importAction="customersImport"
              instructions='<ol class="mb-4">
                            <li>Name</li>
                            <li>Address 1 (optional)</li>
                            <li>Address 2 (optional)</li>
                            <li>City (optional)</li>
                            <li>Province (optional)</li>
                            <li>Postal code (optional)</li>
                            <li>Email (optional)</li>
                            <li>Phone (optional)</li>
                            <li>Type i.e. Registered user, Accredited representative, Duty free, Ships store, Licensed user, Excise warehouse, Export, Spirits licensee, LCBO in-bond, LCBO duty-paid, Licensee, Tied house, By the glass (optional)</li>
                            <li>License e.g. licensee number (optional)</li>
                            <li>Currency (optional, default is CAD)</li>
                            <li>Contact name (optional)</li>
                            <li>Contact title (optional)</li>
                            <li>Contact email (optional)</li>
                            <li>Contact phone (optional)</li>
                            <li>Category (optional)</li>
                            <li>Shipment zone (optional)</li>
                            </ol>
                            <em>Note that not all information for a customer can be imported.</em>
                            You should, therefore, check each imported customer to ensure all settings are correct.'
              @refresh="$refs.table.buildList();$store.commit('customersReset')"/>

    <purtrak-table name="customers" objectType="customers" :defaultColumns="defaultColumns" :headers="headers" ref="table" show-select show-expand
                   listEndPoint="customers2" v-model="selected"
                   fields="id,parent{id,name},name,active,type,license,salesRep{id,name},
                            email,phone,category{id,name},notes,currency,
                            shippingAddress {line1,line2,city,province,postalCode,country},
                            billingAddress {line1,line2,city,province,postalCode,country},
                            shipmentZone{id,name}"
                   :listFilters="listFilters"
                   :item-class="customer => (!customer.active ? 'grey--text ' : '')"
                   @dblclick="customer => $router.push({name:'SalesShipments',query:{customerId:customer.id,customerName:customer.name}})"
                   @itemExpanded="({item, value}) => expand(item, value)"
                   @list="obj => finishList(obj)"
                   title="Customers"
                   :print-info="{pageSize:'landscape',
                                 subTitle:[filters.status!='1'?(filters.status=='0'?'Inactive':'All'):'',
                                          filters.type==''?'':types.length?types.find(t=>t.value==filters.type).text:'',
                                          filters.categoryId!=null?categoryName:'',
                                          filters.salesRepId!=null?salesRepName:'',
                                          filters.shipmentZoneId!=null?shipmentZoneName:'']}"
                   download-endpoint="customersExportCSV">
      <template v-slot:filter>
        <filter-menu include-reset @reset="filters.search='';filters.status='1';filters.type='';filters.categoryId=null;filters.salesRepId=null;filters.shipmentZoneId=null">
          <v-list-item>
            <filter-search label="Customer name" v-model="filters.search"/>
          </v-list-item>
          <v-list-item>
            <v-autocomplete label="Status" dense outlined :items="[{value:'2',text:'All'},{value:'1',text:'Active'},{value:'0',text:'Inactive'}]" v-model="filters.status"/>
          </v-list-item>
          <v-list-item>
            <v-autocomplete label="Customer type" dense outlined :items="types" v-model="filters.type"/>
          </v-list-item>
          <v-list-item>
            <inventory-categories-select v-model="filters.categoryId" label="Category" type="Customer" :name.sync="categoryName" none-text="All"/>
          </v-list-item>
          <v-list-item v-if="salesReps && salesReps.length > 2 && !restrictedToSalesRep">
            <v-autocomplete label="Sales representative" dense outlined :items="salesReps" item-value="id" item-text="name" v-model="filters.salesRepId"/>
          </v-list-item>
          <v-list-item>
            <shipment-zones-select v-model="filters.shipmentZoneId" label="Shipment zone" :name.sync="shipmentZoneName" none-text="All"/>
          </v-list-item>
        </filter-menu>
        <template v-if="!$vuetify.breakpoint.mobile">
          <v-chip v-show="filters.search" close small class="ml-1" @click:close="filters.search=''">Customer: {{filters.search}}</v-chip>
          <v-chip v-show="filters.status!='1'" close small class="ml-1" @click:close="filters.status='1'">{{filters.status=='0'?'Inactive':'All'}}</v-chip>
          <v-chip v-show="filters.type!=''" close small class="ml-1" @click:close="filters.type=''">{{types.length?types.find(t=>t.value==filters.type).text:''}}</v-chip>
          <v-chip v-show="filters.categoryId!=null" close small class="ml-1" @click:close="filters.categoryId=null">{{categoryName}}</v-chip>
          <v-chip v-show="filters.salesRepId!=null" close small class="ml-1" @click:close="filters.salesRepId=null">{{salesRepName}}</v-chip>
          <v-chip v-show="filters.shipmentZoneId!=null" close small class="ml-1" @click:close="filters.shipmentZoneId=null">{{shipmentZoneName}}</v-chip>
        </template>
      </template>
      <template v-slot:menu>
        <template v-if="!readOnly">
          <v-list-item :to="{name:'SalesCustomersEditNew'}"><v-list-item-title>Create customer</v-list-item-title></v-list-item>
          <v-divider/>
        </template>
        <v-list-item :to="{name:'SalesCustomersCategories'}"><v-list-item-title>Categories</v-list-item-title></v-list-item>
        <template v-if="!$vuetify.breakpoint.mobile">
          <v-divider/>
          <v-list-item @click="doImport=true"><v-list-item-title>Import customers from CSV</v-list-item-title></v-list-item>
        </template>
        <template v-if="$store.getters.company.connectedToAccounting">
          <v-divider/>
          <v-list-item @click="sync"><v-list-item-title>Sync customers with QBO</v-list-item-title></v-list-item>
        </template>
      </template>

      <template v-slot:footer v-if="selected.length">
        <v-icon style="position: absolute" class="mt-3 ml-3">mdi-arrow-up-left</v-icon>
        <v-menu offset-y top>
          <template v-slot:activator="{ on }">
            <v-btn color="primary" outlined x-small style="position: absolute" class="mt-5 ml-10" v-on="on">Batch commands</v-btn>
          </template>
          <v-list dense>
            <sales-customers-batch-edit :customers="selected" @refresh="$refs.table.buildList($event)"/>
            <v-divider/>
            <v-list-item @click="deleteMultiple=true;showDelete=true"><v-list-item-title>Delete</v-list-item-title></v-list-item>
          </v-list>
        </v-menu>
      </template>
      <template v-slot:item.name="{item,printing}">
        <template v-if="printing">{{item.name}}</template>
        <template v-else>
          <div :style="item.parent && indentChildren ? 'text-indent:' + (item._level * 30) + 'px' :''">
            <v-hover v-if="!readOnly" v-slot="{hover}">
              <a @click.stop="$router.push({name:'SalesCustomersEdit',params:{customerId:item.id}})"
                 :class="{'text-decoration-underline':hover}">{{item.name}}</a>
            </v-hover>
            <template v-else>{{item.name}}</template>
            <div v-if="item.parent && !indentChildren" class="text-caption">
              Sub-Customer of {{item.parent.name}}
            </div>
          </div>
        </template>
      </template>
      <template v-slot:item.id="{item,printing}">
        <template v-if="printing">{{item.id}}</template>
        <template v-else>
          <span :id="item.id">{{item.id}}</span><copy-to-clipboard class="ml-1" :contentId="item.id"/>
        </template>
      </template>
      <template v-slot:item.type="{item}">
        {{type(item)}}
      </template>
      <template v-slot:item.category.name="{item}">
        {{item.category ? item.category.name : ''}}
      </template>
      <template v-slot:item.salesRepName="{item}">
        {{item.salesRep ? item.salesRep.name : ''}}
      </template>
      <template v-slot:item.shipmentZoneName="{item}">
        {{item.shipmentZone ? item.shipmentZone.name : ''}}
      </template>
      <template v-slot:header.action v-if="!readOnly">
        <v-btn fab color="primary" small :to="{name:'SalesCustomersEditNew'}"><v-icon>mdi-plus</v-icon></v-btn>
      </template>
      <template v-slot:item.action="{item}" v-if="!readOnly">
        <v-menu :nudge-width="150" offset-y>
          <template v-slot:activator="{ on }">
            <v-btn small v-on="on" v-if="$vuetify.breakpoint.mobile" outlined>Customer operations</v-btn>
            <v-btn small icon v-on="on" v-else><v-icon small>mdi-dots-vertical</v-icon></v-btn>
          </template>
          <v-list dense>
            <template  v-if="!readOnly">
              <v-menu :nudge-left="170">
                <template v-slot:activator="{on:create}">
                  <v-list-item v-on="create">
                    <v-list-item-title>Create</v-list-item-title>
                    <v-list-item-action><v-icon>mdi-chevron-right</v-icon></v-list-item-action>
                  </v-list-item>
                </template>
                <v-list dense>
                  <v-list-item :to="{name:'SalesSalesOrdersEditNew',params:{customerId:item.id}}"><v-list-item-title>Sales order</v-list-item-title></v-list-item>
                  <v-list-item :to="{name:'SalesShipmentsEditNew',params:{customerId:item.id}}"><v-list-item-title>Shipment</v-list-item-title></v-list-item>
                  <v-list-item :to="{name:'SalesEstimatesEditNew',params:{customerId:item.id}}"><v-list-item-title>Estimate</v-list-item-title></v-list-item>
                </v-list>
              </v-menu>
              <v-divider/>
            </template>
            <v-menu :nudge-left="170" v-if="!readOnly">
              <template v-slot:activator="{on:view}">
                <v-list-item v-on="view">
                  <v-list-item-title>View</v-list-item-title>
                  <v-list-item-action><v-icon>mdi-chevron-right</v-icon></v-list-item-action>
                  <v-divider/>
                </v-list-item>
              </template>
              <v-list dense>
                <v-list-item :to="{name:'SalesSalesOrders',query:{customerId:item.id,search:item.name,searchField:'customerName'}}"><v-list-item-title>Sales orders</v-list-item-title></v-list-item>
                <v-list-item :to="{name:'SalesShipments',query:{customerId:item.id,customerName:item.name}}"><v-list-item-title>Shipments</v-list-item-title></v-list-item>
                <v-list-item :to="{name:'SalesInvoices',query:{customerId:item.id,search:item.name,searchField:'customerName'}}"><v-list-item-title>Invoices</v-list-item-title></v-list-item>
                <v-list-item :to="{name:'SalesEstimates',query:{customerId:item.id,search:item.name,searchField:'customerName'}}"><v-list-item-title>Estimates</v-list-item-title></v-list-item>
              </v-list>
            </v-menu>
            <v-menu :nudge-left="170" v-if="!readOnly">
              <template v-slot:activator="{on:report}">
                <v-list-item v-on="report">
                  <v-list-item-title>Report</v-list-item-title>
                  <v-list-item-action><v-icon>mdi-chevron-right</v-icon></v-list-item-action>
                  <v-divider/>
                </v-list-item>
              </template>
              <v-list dense>
                <v-list-item :to="{name:'ReportsView',params:{back:[{text:'Customers',to:{name:'SalesCustomers'}}]},query:{to:'reports/sales/ReportsSalesByItem',customerId:item.id}}"><v-list-item-title>Sales summary</v-list-item-title></v-list-item>
                <v-list-item :to="{name:'ReportsView',params:{back:[{text:'Customers',to:{name:'SalesCustomers'}}]},query:{to:'reports/sales/ReportsSalesDetailsByItem',customerId:item.id}}"><v-list-item-title>Sales detail</v-list-item-title></v-list-item>
              </v-list>
            </v-menu>
            <template v-if="audit">
              <v-divider/>
              <v-list-item v-if="audit" :to="{name:'Audit',query:{entityId:item.id}}"><v-list-item-title>Audit history</v-list-item-title></v-list-item>
            </template>
            <template v-if="!readOnly">
              <v-divider/>
              <v-list-item :to="{name:'SalesCustomersEdit',params:{customerId:item.id}}"><v-list-item-title>Edit customer</v-list-item-title></v-list-item>
              <v-list-item @click="customer=item;deleteMultiple=false;showDelete=true"><v-list-item-title>Delete customer</v-list-item-title></v-list-item>
            </template>
          </v-list>
        </v-menu>
      </template>
      <template v-slot:expanded-item="{ headers,item }">
        <td :colspan="headers.length">
          <v-card class="my-4 text-caption" :class="expansionPanelClass">
          <v-container>
            <v-row>
              <v-col>
                <v-card flat :class="expansionPanelClass">
                  <div>{{item.email}}</div>
                  <div>{{item.phone}}</div>
                  <div v-if="item.notes">{{item.notes}}</div>
                </v-card>
              </v-col>
              <v-col>
                <v-card flat :class="expansionPanelClass">
                  <div class="font-weight-bold">Billing address</div>
                  <div>{{item.billingAddress.line1}}</div>
                  <div v-show="item.billingAddress.line2">{{item.billingAddress.line2}}</div>
                  <div>{{item.billingAddress.city}} {{item.billingAddress.province}} {{item.billingAddress.postalCode}}</div>
                </v-card>
              </v-col>
              <v-col>
                <v-card flat v-if="item.shippingAddress" :class="expansionPanelClass">
                  <div class="font-weight-bold">Shipping address</div>
                  <div>{{item.shippingAddress.line1}}</div>
                  <div v-show="item.shippingAddress.line2">{{item.shippingAddress.line2}}</div>
                  <div>{{item.shippingAddress.city}} {{item.shippingAddress.province}} {{item.shippingAddress.postalCode}}</div>
                </v-card>
              </v-col>
            </v-row>
            <v-row v-if="item.contacts && item.contacts.length">
              <v-col cols="9">
                <v-container>
                  <v-row dense>
                    <v-col cols="4"><strong>Contact</strong></v-col>
                    <v-col cols="2"><strong>Title</strong></v-col>
                    <v-col cols="4"><strong>Email</strong></v-col>
                    <v-col cols="2"><strong>Phone</strong></v-col>
                  </v-row>
                  <v-row v-for="(contact,index) in item.contacts" :key="index" dense>
                    <v-col cols="4">{{contact.name}}</v-col>
                    <v-col cols="2">{{contact.title}}</v-col>
                    <v-col cols="4">{{contact.email}}</v-col>
                    <v-col cols="2">{{contact.phone}}</v-col>
                  </v-row>
                </v-container>
              </v-col>
            </v-row>
          </v-container>
          </v-card>
        </td>
      </template>
    </purtrak-table>

    <delete-object v-model="showDelete" :name="deleteMultiple?'ALL selected customers':'customer.name'" @delete="performDelete(customer.id);$store.commit('customersReset')"/>
  </div>
</template>

<script>
import performDelete from '@/mixins/performDelete'
import CopyToClipboard from '@/components/CopyToClipboard'
import customerTypes from '@/mixins/customerTypes'
import InventoryCategoriesSelect from '@/views/inventory/categories/InventoryCategoriesSelect'
import SalesCustomersBatchEdit from '@/views/sales/customers/SalesCustomersBatchEdit'
import ShipmentZonesSelect from '@/views/sales/shipmentZones/SalesShipmentZonesSelect'

export default {
  name: 'SalesCustomers',
  mixins: [customerTypes,performDelete],
  components: {CopyToClipboard,InventoryCategoriesSelect,SalesCustomersBatchEdit,ShipmentZonesSelect},
  data() {
    return {
      filters: {
        status: '1',
        type:'',
        categoryId: null,
        salesRepId: null,
        shipmentZoneId: null,
        search: '',
      },
      indentChildren: false,
      categoryName: '',
      shipmentZoneName: '',
      types: [],
      salesReps: [{id:null,name:'All'},{divider:true}],
      customer: {},
      showDelete: false,
      deleteMultiple: false,
      doImport: false,
      defaultColumns: [{ value: 'name', visible:true},
                       { value: 'type', visible:true},
                       { value: 'currency', visible:false},
                       { value: 'category.name', visible:false},
                       { value: 'email', visible:false},
                       { value: 'phone', visible:false},
                       { value: 'salesRepName', visible:false},
                       { value: 'shipmentZoneName', visible:false},
                       { value: 'id', visible:false}],
      headers: [{ text: 'NAME', value: 'name', width:'50%',sortable:true},
                { text: 'TYPE', value: 'type' ,width:'15%',sortable:false},
                { text: 'CATEGORY', value: 'category.name', width:'20%',sortable:false},
                { text: 'CURRENCY', value: 'currency' ,width:'10%',align:'left'},
                { text: 'EMAIL', value: 'email' ,width:'20%',sortable:false},
                { text: 'PHONE', value: 'phone' ,width:'15%',sortable:false},
                { text: 'SALES REP', value: 'salesRepName', width:'20%',sortable:true},
                { text: 'ZONE', value: 'shipmentZoneName', width:'10%',sortable:true},
                { text: 'ID', value: 'id' ,width:'10%',sortable:false}]
    }
  },
  computed: {
    company() {
      return this.$store.getters.company;
    },
    readOnly() {
      return !this.company.permissions.includes('selling.write');
    },
    audit() {
      return this.company.allowAudit && this.company.permissions.includes('audit');
    },
    listFilters() {
      const filters = [];
      if (this.filters.search)
        filters.push({field:'name', comparator:'contains', value:this.filters.search});
      if (this.filters.status != '2')
        filters.push({field:'active', comparator:'eq', value:this.filters.status === '1' ? 'true' : 'false'});
      if (this.filters.type != '')
        filters.push({field:'type', comparator:'eq', value:this.filters.type});
      if (this.filters.categoryId)
        filters.push({field:'categoryId', comparator:'eq', value:this.filters.categoryId});
      if (this.filters.salesRepId)
        filters.push({field:'salesRepId', comparator:'eq', value:this.filters.salesRepId});
      if (this.filters.shipmentZoneId)
        filters.push({field:'shipmentZoneId', comparator:'eq', value:this.filters.shipmentZoneId});
      return filters;
    },
    salesRepName() {
      return this.salesReps?.find(salesRep => salesRep.id === this.filters.salesRepId)?.name ?? '';
    },
    restrictedToSalesRep() {
      return this.salesReps.find(rep => rep.userId === this.$store.state.user.sub && rep.restricted);
    }
  },
  async created() {
    this.types = [{text:'All',value:''}, ... await this.buildCustomerTypes()];
    this.$store.dispatch('checkTasks');
    this.$lazyListLoad(this.salesReps, 'salesReps2', 'id,name,userId,restricted', 100, [{field:'active', comparator:'eq', value:'true'}])
  },
  methods: {
    type(item) {
      return item.type === 'None' ? '' : `${this.types.find(t=>t.value == item.type)?.text} ${item.license}`;

    },
    async expand({item, value}) {
      if (value && !item.contacts) {
        this.loading = true;
        const results = await this.$apiCall(`query SalesCustomers($id:ID!) {
                                                  customer(id:$id) {
                                                    contacts {
                                                      name,title,email,phone
                                                    }
                                                  }
                                                }`,
                                            {id:item.id});
        this.$set(item, 'contacts', results.data.customer.contacts);
        this.loading = false;
      }
    },
    finishList({list, sortBy}) {
      this.indentChildren = sortBy === 'name' || !sortBy;
      if (this.indentChildren) {
        const edgesToMove = list.edges.filter(edge => edge.node.parent);
        edgesToMove.forEach(edge => {
          let parentIndex = list.edges.findIndex(e => e.node.id === edge.node.parent.id);
          if (parentIndex !== -1) {
            const index = list.edges.findIndex(e => e.node.id === edge.node.id);
            if (index < parentIndex)
              parentIndex--;

            let numberToDelete = 1;
            let i = index+1;
            while (list.edges[i++]?.node.parent?.id === list.edges[index].node.id)
              numberToDelete++;

            const deletedEdges = list.edges.splice(index, numberToDelete);
            edge.node._level = (list.edges[parentIndex].node._level ?? 0) + 1;
            while (list.edges[parentIndex+1]?.node.parent?.id === edge.node.parent.id)
              parentIndex++;
            list.edges.splice(parentIndex+1, 0, ...deletedEdges)
          }
        });
      }
    },
    async sync() {
      this.loading = true;
      const results = await this.$apiCall(`mutation SalesCustomers {
                                             accountingIntegrationSync(step:"customers") {name}
                                           }`, {});
      if (!results.error) {
        this.$store.commit('setError', {type:'success',message:`Synced customers with QBO`});
        this.$refs.table?.buildList();
      }
    }
  }
}
</script>